/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
// version: major.minor.patch
export const version = '0.2.1';
